(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbStatusConfigDataStore', [
			'$q', 
			'smbStatusConfigService', 
			StatusConfigDataStore
			]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbStatusConfigDataStore
	 * 
	 * @description
	 * Data store that manages state for the content type configuration section.
	 */
	function StatusConfigDataStore($q, smbStatusConfigService) {

		var _contentStatus;
		var _todoStatus;
		var _assignedUserId;
		var _assignedDate;

		var _contentStatusValues = [];
		var _todoStatusValues = [];

		return {
			/**
			 * @ngdoc method
			 * @name smbStatusConfigDataStore.getContentStatuses
			 * @methodOf smb-app.smbStatusConfigDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads the data store with a content type by id
			 * 
			 * @param {String} groupId Id of the content type group the type belongs to
			 * @param {String} id The content type id
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
			 */
			get contentStatus() { return _contentStatus; },

			get todoStatus() { return _todoStatus; },

			get contentStatusValues() { return _contentStatusValues; },

			get todoStatusValues() { return _todoStatusValues; },

			get assignedUserId() { return _assignedUserId; },

			get assignedDate() { return _assignedDate; },

			loadStatuses: loadStatuses,

			// loadStatusValues: loadStatusValues,
			
			/**
			 * @ngdoc method
			 * @name smbStatusConfigDataStore.saveContentStatuses
			 * @methodOf smb-app.smbStatusConfigDataStore
			 * @kind function
			 * 
			 * @description
			 * Saves changes to the current content type. Creates it if it is a new one and
			 * updates it if it is an existing one.
			 * 
			 * @param {String} groupId The id of the content type group it belongs to
			 * @param {ContentType} contentType The content type object to save.
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the saved content type
			 */

			saveStatuses: saveStatuses
		};

		function loadStatuses(groupId) {
			return smbStatusConfigService.getStatuses(groupId)
			.then(function mapStatuses(statuses) {
				_contentStatus = statuses.filter(function filterCStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Content_Status/);
				});
				_todoStatus = statuses.filter(function filterTStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_ToDo_Status/);
				});
				_assignedUserId = statuses.filter(function filterCStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
				});
				_assignedDate = statuses.filter(function filterTStatuses(s) {
					return s.TagTypeName.match(/&&_AirBase_Assigned_Date/);
				});
				return statuses;
			});
		}

		// function loadStatusValues(folderId, contentStatus, todoStatus) {
		// 	return smbStatusConfigService.getStatusValues(folderId, contentStatus.TagTypeId)
		// 			.then(function setContentStatusValues(response) {
		// 				_contentStatusValues = response.data;
		// 				return response.data;
		// 			})
		// 			.then(function loadToDoStatusValues() {
		// 				return smbStatusConfigService.getStatusValues(folderId, todoStatus.TagTypeId);
		// 			})
		// 			.then(function setToDoStatusValues(response) {
		// 				_todoStatusValues = response.data;
		// 				return response.data;
		// 			});
		// }

		function saveStatuses(folderId, contentStatus, todoStatus) {
			return smbStatusConfigService.setStatuses(folderId, contentStatus.TagTypeId, contentStatus.Constraints)
				.then(function saveToDoStatuses() {
					return smbStatusConfigService.setStatuses(folderId, todoStatus.TagTypeId, todoStatus.Constraints);
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/statusConfigDataStore.js
// module id = 111
// module chunks = 1